import { ReactNode } from 'react';
import { css } from '@emotion/react';
import { Avatar, Button, ContentLoader, PopoverMenu, Text, usePopoverMenu } from '@frontend/design-system';
import { ScheduleRequestsTrackingIds } from '../../trackingIds';

type Props = {
  name: string;
  isLoading: boolean;
  locationName: string;
  primaryMeta?: ReactNode;
  secondaryMeta?: ReactNode;
  menuItems: ReactNode;
  modals: ReactNode;
  locationChip?: (locationName: string) => React.ReactNode;
  getTriggerProps: ReturnType<typeof usePopoverMenu>['getTriggerProps'];
  getMenuProps: ReturnType<typeof usePopoverMenu>['getMenuProps'];
};

export const ScheduleRequestItemHeaderUI = ({
  name,
  isLoading,
  locationName,
  primaryMeta,
  secondaryMeta,
  menuItems,
  modals,
  locationChip,
  getTriggerProps,
  getMenuProps,
}: Props) => (
  <>
    <ContentLoader show={isLoading} size='small' />
    <div css={containerStyles}>
      <div css={requestInfoStyle}>
        <Avatar name={name} size='large' />
        <div>
          <div css={primaryInfoStyles}>
            <Text textAlign='left' weight='bold'>
              {name}
            </Text>
            {primaryMeta}
          </div>
          <div css={secondaryInfoStyles}>{secondaryMeta}</div>
        </div>
      </div>

      <div css={actionsStyles}>
        {locationChip && typeof locationChip === 'function' && locationChip(locationName)}
        <Button
          variant='secondary'
          iconName='more-small'
          trackingId={ScheduleRequestsTrackingIds.requestListItemMoreBtn}
          {...getTriggerProps()}
        />
        <PopoverMenu {...getMenuProps()}>{menuItems}</PopoverMenu>
      </div>
    </div>
    {modals}
  </>
);

const containerStyles = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
  gap: var(--fabric-space-gap-md);
`;

const requestInfoStyle = css`
  display: flex;
  align-items: center;
  flex: 1;
  gap: var(--fabric-space-gap-sm);
`;

const primaryInfoStyles = css`
  display: flex;
  align-items: center;
  gap: var(--fabric-space-gap-xs);
`;

const secondaryInfoStyles = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const actionsStyles = css`
  display: flex;
  align-items: center;
  gap: var(--fabric-space-gap-xs);
`;
